module.exports = __webpack_public_path__ + "img/s1.ff7e3b19.png";